import React, { Fragment, useContext, useState, useEffect } from 'react'
import { Transition, Menu } from '@headlessui/react'
import AuthContext from '../context/AuthContext'
import { Link, useLocation } from 'react-router-dom'
import OImage from './reusable/OImage'
import { t } from 'i18next'
import { apiGet } from 'utils/apiFetch'
import apiPath from 'utils/pathObj'
import bellIcon from '../../src/assets/images/bell.png'
import Notification from './Notification'

const TopNavBar = () => {
  const { 
    logoutUser, 
    user, 
    handleSidebar, 
    pageName, 
    updatePageName, 
    companyCompletionStatus 
  } = useContext(AuthContext)
  
  const location = useLocation()
  const [notification, setNotification] = useState(false)

  const handleLogout = () => {
    if (window.confirm('Are you sure to logout?')) {
      logoutUser()
    }
  }

  const getNotification = async () => {
    if (!sessionStorage.getItem('token')) return
    try {
      const path = apiPath.checkNotification
      const result = await apiGet(path, {}, { skipLoader: true })
      setNotification(result?.data?.results?.unreadNotification)
    } catch (error) {
      console.log('error:', error)
    }
  }

  const handelApiCall = () => {
    getNotification()
  }

  useEffect(() => {
    getNotification()
  }, [location.pathname])

  // ─── DYNAMIC RED TEXT LOGIC ───
  // Just use the exact message the backend sends.
  const isComplete = companyCompletionStatus?.message === "Your company profile is completed!" || companyCompletionStatus?.isProfileComplete === true;
  const redMessage = companyCompletionStatus?.message;

  return (
    <div className='linHeader border-b py-4 px-4 md:px-8'>
      <header className='bg-white items-center flex'>
        <link href='/firebase-messaging-sw.js'></link>
        <Notification />
        <div className='mr-4' onClick={() => handleSidebar()}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='1.5'
            stroke='currentColor'
            className='w-6 h-6'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
            />
          </svg>
        </div>

        <div className='page_heading flex items-center'>
          <h1 className='flex items-center text-lg text-slate-900'>
            {pageName}
            {!isComplete && redMessage && (
              <>
                .<span className='text-sm text-red-500 ml-1'>({redMessage})</span>
              </>
            )}
          </h1>
        </div>
        
        <Menu
          as='div'
          className='relative inline-block text-left hover:text-LightBlue sidebar_dropdown ml-auto'
        >
          <div>
            <Menu.Button className='flex relative items-center w-full text-white active:text-LightBlue hover:bg-white hover:text-LightBlue group'>
              <span title={t('O_NOTIFICATION')}>
                <div className='flex justify-end '>
                  {notification ? (
                    <Link
                      to='/notification-list'
                      className='mr-4 relative'
                      onClick={() => handelApiCall()}
                    >
                      <img src={bellIcon} alt='bellIcon' className='w-5' />
                      <span className='absolute top-0 right-0 w-0.5 h-0.5 bg-red-500 flex justify-center items-center rounded-full text-white p-1 d-block text-xs font-bold'></span>
                    </Link>
                  ) : (
                    <Link to='/notification-list' className='mr-4 relative'>
                      <img src={bellIcon} alt='bellIcon' className='w-5' />
                    </Link>
                  )}
                </div>
              </span>
              <div className='profile flex items-center ml-auto md:mr-10 mr-2'>
                <figure className='inline-block overflow-hidden rounded-full'>
                  <OImage
                    src={user?.profilePicture}
                    fallbackUrl='/images/user.png'
                    className='w-[40px] h-[40px] inline'
                    alt=''
                  />
                </figure>
                <small className='text-sm text-slate-900 ml-2 md:block hidden'>
                  {user?.name}
                </small>
              </div>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-10'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'
          >
            <Menu.Items className='absolute z-10 text-left min-w-[200px]  right-2 content divide-y divide-gray-100  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
              <div className=''>
                <Menu.Item onClick={() => updatePageName('Edit profile')}>
                  {({ active }) => (
                    <Link
                      to='/profile'
                      className={`${
                        active ? 'bg-LightBlue text-white' : 'text-gray-900'
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Edit profile
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item onClick={() => updatePageName('Change password')}>
                  {({ active }) => (
                    <Link
                      to='/change-password'
                      className={`${
                        active ? 'bg-LightBlue text-white' : 'text-gray-900'
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Change password
                    </Link>
                  )}
                </Menu.Item>
              </div>
              <div className=''>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLogout}
                      className={`${
                        active ? 'bg-LightBlue text-white' : 'text-gray-900'
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Logout
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </header>
    </div>
  )
}

export default TopNavBar





// import React, { Fragment, useContext, useState, useEffect } from 'react'
// import { Transition, Menu } from '@headlessui/react'
// import AuthContext from '../context/AuthContext'
// import { Link, useLocation } from 'react-router-dom'
// import OImage from './reusable/OImage'
// import { t } from 'i18next'
// import { apiGet } from 'utils/apiFetch'
// import apiPath from 'utils/pathObj'
// import bellIcon from '../../src/assets/images/bell.png'
// import Notification from './Notification'

// const TopNavBar = () => {
//   const { logoutUser, user, handleSidebar, pageName, updatePageName,companyCompletionStatus } = useContext(AuthContext)
//   const location = useLocation()
//   const [notification, setNotification] = useState(false)

//   const handleLogout = () => {
//     if (window.confirm('Are you sure to logout?')) {
//       logoutUser()
//     }
//   }

//   const getNotification = async () => {
//     if (!sessionStorage.getItem('token')) return
//     try {
//       const path = apiPath.checkNotification
//       const result = await apiGet(path, {}, { skipLoader: true })
//       setNotification(result?.data?.results?.unreadNotification)
//     } catch (error) {
//       console.log('error:', error)
//     }
//   }

//   const handelApiCall = () => {
//     getNotification()
//   }

//   useEffect(() => {
//     getNotification()
//   }, [location.pathname])

//   return (
//     <div className='linHeader border-b py-4 px-4 md:px-8'>
//       <header className='bg-white items-center flex'>
//         <link href='/firebase-messaging-sw.js'></link>
//         <Notification />
//         <div className='mr-4' onClick={() => handleSidebar()}>
//           <svg
//             xmlns='http://www.w3.org/2000/svg'
//             fill='none'
//             viewBox='0 0 24 24'
//             strokeWidth='1.5'
//             stroke='currentColor'
//             className='w-6 h-6'
//           >
//             <path
//               strokeLinecap='round'
//               strokeLinejoin='round'
//               d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
//             />
//           </svg>
//         </div>

//         <div className='page_heading flex items-center'>
//           <h1 className='flex items-center text-lg text-slate-900'>
//             {pageName}{companyCompletionStatus?.message !== "Your company profile is completed!" ? (<>.<span className='text-sm text-red-500'>({companyCompletionStatus.message})</span></>) : null}
//           </h1>
//         </div>
//         <Menu
//           as='div'
//           className='relative inline-block text-left hover:text-LightBlue sidebar_dropdown ml-auto'
//         >
//           <div>
//             <Menu.Button className='flex relative items-center w-full text-white active:text-LightBlue hover:bg-white hover:text-LightBlue group'>
//               <span title={t('O_NOTIFICATION')}>
//                 <div className='flex justify-end '>
//                   {notification ? (
//                     <Link
//                       to='/notification-list'
//                       className='mr-4 relative'
//                       onClick={() => handelApiCall()}
//                     >
//                       <img src={bellIcon} alt='bellIcon' className='w-5' />
//                       <span className='absolute top-0 right-0 w-0.5 h-0.5 bg-red-500 flex justify-center items-center rounded-full text-white p-1 d-block text-xs font-bold'></span>
//                     </Link>
//                   ) : (
//                     <Link to='/notification-list' className='mr-4 relative'>
//                       <img src={bellIcon} alt='bellIcon' className='w-5' />
//                     </Link>
//                   )}
//                 </div>
//               </span>
//               <div className='profile flex items-center ml-auto md:mr-10 mr-2'>
//                 <figure className='inline-block overflow-hidden rounded-full'>
//                   <OImage
//                    src={user?.profilePicture === "https://d2n5q7sk1gggpw.cloudfront.net/no_image.png" ? '/images/No-image-found.jpg': user?.profilePicture }
//                     fallbackUrl='/images/No-image-found.jpg'
//                     className='w-[40px] h-[40px] inline'
//                     alt=''
//                   />
//                 </figure>
//                 <small className='text-sm text-slate-900 ml-2 md:block hidden'>
//                   {user?.name}
//                 </small>
//               </div>
//             </Menu.Button>
//           </div>
//           <Transition
//             as={Fragment}
//             enter='transition ease-out duration-10'
//             enterFrom='transform opacity-0 scale-95'
//             enterTo='transform opacity-100 scale-100'
//             leave='transition ease-in duration-75'
//             leaveFrom='transform opacity-100 scale-100'
//             leaveTo='transform opacity-0 scale-95'
//           >
//             <Menu.Items className='absolute z-10 text-left min-w-[200px]  right-2 content divide-y divide-gray-100  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
//               <div className=''>
//                 <Menu.Item onClick={() => updatePageName('Edit profile')}>
//                   {({ active }) => (
//                     <Link
//                       to='/profile'
//                       className={`${
//                         active ? 'bg-LightBlue text-white' : 'text-gray-900'
//                       } group flex w-full items-center  px-6 py-2 text-sm`}
//                     >
//                       Edit profile
//                     </Link>
//                   )}
//                 </Menu.Item>
//                 <Menu.Item onClick={() => updatePageName('Change password')}>
//                   {({ active }) => (
//                     <Link
//                       to='/change-password'
//                       className={`${
//                         active ? 'bg-LightBlue text-white' : 'text-gray-900'
//                       } group flex w-full items-center  px-6 py-2 text-sm`}
//                     >
//                       Change password
//                     </Link>
//                   )}
//                 </Menu.Item>
//               </div>
//               <div className=''>
//                 <Menu.Item>
//                   {({ active }) => (
//                     <button
//                       onClick={handleLogout}
//                       className={`${
//                         active ? 'bg-LightBlue text-white' : 'text-gray-900'
//                       } group flex w-full items-center  px-6 py-2 text-sm`}
//                     >
//                       Logout
//                     </button>
//                   )}
//                 </Menu.Item>
//               </div>
//             </Menu.Items>
//           </Transition>
//         </Menu>
//       </header>
//     </div>
//   )
// }

// export default TopNavBar
